export interface Role {
    id: number;
    slug: string;
    name: string;
    description: string;
}
